"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigestEmailSectionSchema = exports.DeliveryCadenceSchema = void 0;
const zod_1 = require("zod");
exports.DeliveryCadenceSchema = zod_1.z.enum(['multiWeekly', 'weekly', 'daily']);
exports.DigestEmailSectionSchema = zod_1.z.enum([
    'borrowingBaseSummary',
    'concentrationLimit',
    'ineligibleReceivables',
    'cashBalance',
    'deliverables',
]);
//# sourceMappingURL=Email.js.map